import { LDOptions } from 'launchdarkly-react-client-sdk';
import { basicLogger } from 'launchdarkly-js-client-sdk';

export interface LaunchDarklyConfig {
  clientSideID: string;
  options?: LDOptions;
}

export const launchDarklyConfig: LaunchDarklyConfig = {
  clientSideID: process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID || '',
  options: {
    logger: basicLogger({ level: 'none' }),
  },
};

